import React from 'react';
import { Navigate } from 'react-router-dom';
import { HomeLayout } from 'modules/home/components/HomeLayout';
import { DocumentTypeSection } from 'modules/documentType/components/DocumentTypeSection';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';
import { Paths } from 'services/navigation/paths';

export const HomeDocumentsTab: React.FC = () => {
  const { isAdmin } = useIsAdmin();
  const organization = useOrganization();
  const documentTypesFlag = useFlag(Flags.DOCUMENT_TYPES);

  // `useFlag` returns `undefined` before PostHog has resolved. Redirecting
  // on that transient state would use `replace: true` and never bring the
  // user back once the flag ticks true, so we render nothing and wait for
  // the value to settle before deciding.
  if (documentTypesFlag === undefined) return null;

  // Guard direct URL access — the nav tab is already hidden by the flag,
  // but the route is registered so a bookmarked / typed URL still resolves
  // here. Bounce to /home when the flag is off or the caller isn't an admin.
  if (!isAdmin || !documentTypesFlag) {
    return <Navigate to={Paths.HOME} replace />;
  }

  return (
    <HomeLayout>
      <DocumentTypeSection organizationId={organization.id} />
    </HomeLayout>
  );
};
